usuario.component('usuario.enderecoComponent', {
    templateUrl: 'usuario/endereco/endereco.html',
    controller: 'usuario.enderecoController',
    bindings: { baseUsuario: '<' }
});

usuario.controller('usuario.enderecoController', ['$scope', 'coreUtils', 'coreToast', 'coreFb', 'coreLanguage', function($scope, $utils, $toast, $fb, $text) {

    $scope.$text = $text;
    const $ctrl = this;

    $ctrl.isSubmiting = false;
    $ctrl.submitError = '';
    $ctrl.submitSuccess = false;

    $ctrl.estadoOptions = [];

    $ctrl.cepState = {
        isLoading: false,
        hasError: false
    }

    $ctrl.formData = {};
    $ctrl.dadosData = {};
    $ctrl.dadosErrors = {
        'endereco.cep': {},
        'endereco.logradouro': {},
        'endereco.numero': {},
        'endereco.bairro': {},
        'endereco.complemento': {},
        'endereco.cidade': {},
        'endereco.uf': {},
    };

    $ctrl.validateDadosField = (name) => {

        $ctrl.dadosErrors[name] = {
            field: $scope.usuarioDadosForm[name].$invalid,
            hint: $scope.usuarioDadosForm[name].$invalid
        };
    };

    $ctrl.validateDadosFields = () => {

        Object.keys($ctrl.dadosErrors).forEach(name => {
            $ctrl.dadosErrors[name] = {
                field: $scope.usuarioDadosForm[name].$invalid,
                hint: $scope.usuarioDadosForm[name].$invalid
            }
        })
    };

    $ctrl.getModifiedDadosData = () => {

        const modifiedData = {};

        Object.keys($ctrl.dadosData).forEach(name => {
            if ($scope.usuarioDadosForm[name].$dirty) {
                modifiedData[name] = $ctrl.dadosData[name];
            }
        })

        return modifiedData;
    };

    $ctrl.submitDadosForm = () => {

        if (!$scope.usuarioDadosForm.$valid) {
            $ctrl.validateDadosFields();
            return
        }

        $ctrl.formErrors = {};

        $ctrl.isSubmiting = true;
        $ctrl.submitError = '';
        $ctrl.submitSuccess = false;

        const dadosData = $ctrl.getModifiedDadosData();
        $fb.db.update(`/cad_usuarios/${$ctrl.baseUsuario.id}`, dadosData).then(() => {

            $scope.usuarioDadosForm.$setPristine();

            $toast.success($text.successfullUpdate);
            $scope.$emit('update-usuario');

        }).catch(e => {
            $ctrl.submitError = 'internal';

            throw e;
        }).finally(() => {
            $ctrl.isSubmiting = false;
        })
    };    

    $ctrl.onCepUpdate = () => {

        if ($scope.usuarioDadosForm['endereco.cep'].$pristine || !$ctrl.dadosData['endereco.cep'] || $scope.usuarioDadosForm['endereco.cep'].$invalid) {
            return
        }

        $ctrl.cepState.isLoading = true;
        $ctrl.cepState.hasError = false;

        $utils.httpReq('get', `https://viacep.com.br/ws/${$ctrl.dadosData['endereco.cep']}/json`).then(res => {
            if (res?.data.erro) {
                $ctrl.cepState.hasError = true;

                return
            }

            const enderecoData = {
                'endereco.logradouro': res.data.logradouro,
                'endereco.bairro': res.data.bairro,
                'endereco.complemento': res.data.complemento,
                'endereco.cidade': res.data.localidade,
                'endereco.uf': res.data.uf,
            }

            Object.assign($ctrl.dadosData, enderecoData);

            $scope.usuarioDadosForm['endereco.logradouro'].$setDirty();
            $scope.usuarioDadosForm['endereco.bairro'].$setDirty();
            $scope.usuarioDadosForm['endereco.complemento'].$setDirty();
            $scope.usuarioDadosForm['endereco.cidade'].$setDirty();
            $scope.usuarioDadosForm['endereco.uf'].$setDirty();
        }).finally(() => {
            $ctrl.cepState.isLoading = false;
        });
    };    

    $ctrl.$onInit = () => {

        $ctrl.deregisterOnCepUpdated = $scope.$watch("$ctrl.dadosData['endereco.cep']", $ctrl.onCepUpdate);
        $fb.db.get('/sys_dominio/estados').then(res => {
            if(!res.data){ console.log('Not Found: dominio/estados'); return false; }
            $ctrl.estadoOptions = res.data.values;
        })
    };

    $ctrl.$onChanges = (changes) => {

        if (changes.baseUsuario && changes.baseUsuario.currentValue) {
            const baseUsuario = changes.baseUsuario.currentValue.data;
            $ctrl.dadosData = {
                'endereco.cep': baseUsuario.endereco?.cep,
                'endereco.logradouro': baseUsuario.endereco?.logradouro,
                'endereco.numero': baseUsuario.endereco?.numero,
                'endereco.bairro': baseUsuario.endereco?.bairro,
                'endereco.complemento': baseUsuario.endereco?.complemento,
                'endereco.cidade': baseUsuario.endereco?.cidade,
                'endereco.uf': baseUsuario.endereco?.uf,
            };
        }
    };
}])